package com.essntl.uikit.theme

import androidx.compose.ui.graphics.Color

internal val Purple200 = Color(0xFFBB86FC)
internal val Purple500 = Color(0xFF6200EE)
internal val Purple700 = Color(0xFF3700B3)
internal val Teal200 = Color(0xFF03DAC5)

internal val Black = Color(0xFF121212)

internal val Grayscale100 = Color(0xFFFFFFFF)
internal val Grayscale200 = Color(0xFFF7F7F8) // 0xFFF3F3F3
internal val Grayscale300 = Color(0xFFE7E6EB)
internal val Grayscale400 = Color(0xFFC6C5D0)
internal val Grayscale500 = Color(0xFF8985A2)
internal val Grayscale600 = Color(0xFF6E6A8B)
internal val Grayscale700 = Color(0xFF58556A)
internal val Grayscale800 = Color(0xFF121021)
internal val Grayscale900 = Color(0xFF090811)

internal val Primary100 = Color(0xFFF5F5FC)
internal val Primary200 = Color(0xFFEFEDFD)
internal val Primary300 = Color(0xFFCEC8F9)
internal val Primary400 = Color(0xFF8D7EF1)
val Primary500 = Color(0xFF5935E9)
internal val Primary600 = Color(0xFF3412A6)
internal val Primary700 = Color(0xFF190C6E)
internal val Primary800 = Color(0xFF0E073D)
internal val Primary900 = Color(0xFF06041F)

internal val Accent100 = Color(0xFFFDFBEA)
val Accent200 = Color(0xFFFCF6B8)
internal val Accent300 = Color(0xFFFCF0B5)
internal val Accent400 = Color(0xFFFBEB98)
val Accent500 = Color(0xFFFAE36F)
internal val Accent600 = Color(0xFFF8DB47)

internal val Orange200 = Color(0xFFFEF3DC)
internal val Orange300 = Color(0xFFFDE9C2)
internal val Orange400 = Color(0xFFFBDA97)
internal val Orange500 = Color(0xFFFAC867)
internal val Orange500base = Color(0xFFF9C152)
val Orange800 = Color(0xFFF39687)
val Orange900 = Color(0xFFF0D28F)

internal val Green100 = Color(0xFFF5FEFA)
val Green200 = Color(0xFFD9FDEB)
val Green300 = Color(0xFF9FF9CC)
val Green400 = Color(0xFF47EBA9)
internal val Green500 = Color(0xFF0CC078)
val Green600 = Color(0xFF09865C)

val Red50 = Color(0xFFF8C3F9)
internal val Red100 = Color(0xFFFEF4F3)
internal val Red200 = Color(0xFFF9CAC3)
internal val Red300 = Color(0xFFF39587)
internal val Red400 = Color(0xFFEE6B57)
internal val Red500 = Color(0xFFE62B0F)
internal val Red600 = Color(0xFF991D0A)

/**
 * Opacity Reference
 *
 * 100% — FF
 * 99% — FC
 * 98% — FA
 * 97% — F7
 * 96% — F5
 * 95% — F2
 * 94% — F0
 * 93% — ED
 * 92% — EB
 * 91% — E8
 * 90% — E6
 * 89% — E3
 * 88% — E0
 * 87% — DE
 * 86% — DB
 * 85% — D9
 * 84% — D6
 * 83% — D4
 * 82% — D1
 * 81% — CF
 * 80% — CC
 * 79% — C9
 * 78% — C7
 * 77% — C4
 * 76% — C2
 * 75% — BF
 * 74% — BD
 * 73% — BA
 * 72% — B8
 * 71% — B5
 * 70% — B3
 * 69% — B0
 * 68% — AD
 * 67% — AB
 * 66% — A8
 * 65% — A6
 * 64% — A3
 * 63% — A1
 * 62% — 9E
 * 61% — 9C
 * 60% — 99
 * 59% — 96
 * 58% — 94
 * 57% — 91
 * 56% — 8F
 * 55% — 8C
 * 54% — 8A
 * 53% — 87
 * 52% — 85
 * 51% — 82
 * 50% — 80
 * 49% — 7D
 * 48% — 7A
 * 47% — 78
 * 46% — 75
 * 45% — 73
 * 44% — 70
 * 43% — 6E
 * 42% — 6B
 * 41% — 69
 * 40% — 66
 * 39% — 63
 * 38% — 61
 * 37% — 5E
 * 36% — 5C
 * 35% — 59
 * 34% — 57
 * 33% — 54
 * 32% — 52
 * 31% — 4F
 * 30% — 4D
 * 29% — 4A
 * 28% — 47
 * 27% — 45
 * 26% — 42
 * 25% — 40
 * 24% — 3D
 * 23% — 3B
 * 22% — 38
 * 21% — 36
 * 20% — 33
 * 19% — 30
 * 18% — 2E
 * 17% — 2B
 * 16% — 29
 * 15% — 26
 * 14% — 24
 * 13% — 21
 * 12% — 1F
 * 11% — 1C
 * 10% — 1A
 * 9% — 17
 * 8% — 14
 * 7% — 12
 * 6% — 0F
 * 5% — 0D
 * 4% — 0A
 * 3% — 08
 * 2% — 05
 * 1% — 03
 * 0% — 00
 */